var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card shadow h-100 py-2",class:_vm.classe},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row no-gutters align-items-center"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }